import { CURRENT_REGION } from 'config/regions/config';
import { Regions } from 'config/regions/types';

export interface XometryAddress {
  address: string;
  city: string;
  zip: string;
  /** Stored as a code for the countries with a region dropdown, e.g. "KA" for India */
  region?: string;
  country: string;
  company: string;
  phone: string;
  name: string;
}

export const xometryAddressPoland: XometryAddress = {
  address: 'c/o ul. Kasztanowa 6A/1',
  city: 'Mlodasko',
  company: 'Xometry Europe GmbH',
  country: 'Poland',
  name: 'Marcin Chyla',
  phone: '+48 695 332 666',
  zip: '64-542',
};

const xometryAddressEurope: XometryAddress = {
  company: 'Xometry Europe GmbH',
  name: 'Dmitry Kafidov',
  phone: '+49 893 803 4818 *14',
  address: 'Otto-Hahn-Straße 11 C',
  city: 'Hohenbrunn',
  zip: '85521',
  country: 'Germany',
};

const xometryAddressTurkey: XometryAddress = {
  address: 'Yeşilbağlar Mah. D 100 Bul. Pendik Pera Residence A Blok No: 20B Pendik',
  city: 'Istanbul',
  phone: '+90 536 775 80 13',
  company: 'XOMETRY TR TEKNOLOJİ ANONİM ŞİRKETİ',
  country: 'Turkey',
  zip: '34893',
  name: 'Ali Karagoz',
};

const xometryAddressUK: XometryAddress = {
  address: 'Unit 2 Park Road, City Park West',
  city: 'Chelmsford',
  phone: '+44 7895 641 246',
  company: 'Xometry UK LTD',
  country: 'United Kingdom',
  zip: 'CM1 1HF',
  name: 'Jelena Gorelyseva',
};

const xometryAddressSG: XometryAddress = {
  company: 'Xometry India Private Limited',
  name: 'Sinivasan Mohandoss',
  phone: '+919043323428',
  address: '35/10, 1st Main Rd, 2nd Phase, KIADB, Peenya, Karnataka',
  city: 'Bengaluru',
  zip: '560058',
  region: 'KA',
  country: 'India',
};

export const xometryAddressSGVietnam: XometryAddress = {
  company: 'Công Ty Cp May Chiến Thắng (Chigamex)',
  name: 'Ryan Vu',
  phone: '+84-965262529',
  address: '22 P. Thành Công, Giảng Võ',
  city: 'Hà Nội',
  zip: '100000',
  region: 'HN',
  country: 'Viet Nam',
};

export const defaultXometryAddressByRegion: Record<Regions, XometryAddress> = {
  [Regions.EU]: xometryAddressEurope,
  [Regions.TR]: xometryAddressTurkey,
  [Regions.UK]: xometryAddressUK,
  [Regions.SG]: xometryAddressSG,
};

export const defaultXometryAddress = defaultXometryAddressByRegion[CURRENT_REGION];

const xometryShippingAddressesEU: Record<string, XometryAddress> = {
  Hohenbrunn: xometryAddressEurope,
  Glonn: {
    company: 'Xometry Europe GmbH',
    name: 'Dmitry Kafidov',
    phone: '+49 893 803 4818 *14',
    address: 'Steinhausen 20',
    city: 'Glonn',
    zip: '85625',
    country: 'Germany',
  },
  Crailsheim: {
    company: 'Schenker for Xometry',
    name: 'Sven Maly',
    phone: '+49 151 11721 554',
    address: 'Wilhelm-Maybach-Straße 14',
    city: 'Crailsheim',
    zip: '74564',
    country: 'Germany',
  },
  'DB Schenker Eching': {
    company: 'Schenker for Xometry',
    name: 'Bernd Deubel',
    phone: '+49 8165 605 240',
    address: 'Dieselstr. 1',
    city: 'Eching',
    zip: '85386',
    country: 'Germany',
  },
  'DB Schenker Nuremberg': {
    company: 'Schenker for Xometry',
    name: 'Giuseppina Kramer',
    phone: '+49 911 47722 960',
    address: 'Triester Str. 20',
    city: 'Nuremberg',
    zip: '90451',
    country: 'Germany',
  },
  'DB Schenker France': {
    company: 'Schenker FR for Xometry',
    name: 'Julien Pourrier',
    phone: '+33 2 35 13 52 00',
    address: 'Parc du Hode N° Portuaire 5521 Voie des Vanneaux',
    city: "St Vigor D'Ymonville",
    zip: '76430',
    country: 'France',
  },
  'Linther Spedition': {
    company: 'Linther Spedition GmbH',
    name: 'Mayr',
    phone: '+49 89 863003 10',
    address: 'Kronwinkler Str. 31',
    city: 'München',
    zip: '81245',
    country: 'Germany',
  },
};

const xometryShippingAddressesTR: Record<string, XometryAddress> = {
  Istanbul: xometryAddressTurkey,
};

const xometryShippingAddressesUK: Record<string, XometryAddress> = {
  Chelmsford: xometryAddressUK,
  Colnbrook: {
    address: '3 & 6 Britannia Ind Est',
    city: 'Colnbrook, Berkshire',
    phone: '+44 2031 960 178',
    company: 'GOT FREIGHT LTD ',
    country: 'United Kingdom',
    zip: 'SL3 0BH',
    name: 'Jelena Gorelyseva',
  },
};

const xometryShippingAddressesSG: Record<string, XometryAddress> = {
  Bengaluru: xometryAddressSG,
  Vietnam: xometryAddressSGVietnam,
};

const xometryShippingAddressesByRegion: Record<Regions, Record<string, XometryAddress>> = {
  [Regions.EU]: xometryShippingAddressesEU,
  [Regions.TR]: xometryShippingAddressesTR,
  [Regions.UK]: xometryShippingAddressesUK,
  [Regions.SG]: xometryShippingAddressesSG,
};

export const xometryShippingAddresses = xometryShippingAddressesByRegion[CURRENT_REGION];

export const xometryCustomsEmail = 'customs@xometry.de';
export const xometryLogisticsEmail = 'logistics@xometry.de';
